"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataFieldClassificationSchema = exports.MetadataSupplierSourcedCandidateSchema = exports.MetadataSourcedCandidateSchema = exports.MetadataClassificationModeSchema = exports.MetadataClassificationMode = exports.MetadataCandidateSourceMethodSchema = exports.MetadataCandidateSourceMethod = void 0;
const zod_1 = require("zod");
const catalogue_item_1 = require("../../Types/catalogue-item");
var MetadataCandidateSourceMethod;
(function (MetadataCandidateSourceMethod) {
    MetadataCandidateSourceMethod["AiClassification"] = "ai_classification";
    MetadataCandidateSourceMethod["Heuristic"] = "heuristic";
})(MetadataCandidateSourceMethod || (exports.MetadataCandidateSourceMethod = MetadataCandidateSourceMethod = {}));
exports.MetadataCandidateSourceMethodSchema = zod_1.z.nativeEnum(MetadataCandidateSourceMethod);
var MetadataClassificationMode;
(function (MetadataClassificationMode) {
    MetadataClassificationMode["AiOnly"] = "ai_only";
    MetadataClassificationMode["AiWithHeuristicFallback"] = "ai_with_heuristic_fallback";
    MetadataClassificationMode["HeuristicOnly"] = "heuristic_only";
})(MetadataClassificationMode || (exports.MetadataClassificationMode = MetadataClassificationMode = {}));
exports.MetadataClassificationModeSchema = zod_1.z.nativeEnum(MetadataClassificationMode);
exports.MetadataSourcedCandidateSchema = zod_1.z.object({
    value: zod_1.z.string(),
    sourceFieldName: zod_1.z.string(),
    sourceMethod: exports.MetadataCandidateSourceMethodSchema,
});
exports.MetadataSupplierSourcedCandidateSchema = zod_1.z.object({
    value: zod_1.z.string(),
    sourceFieldName: zod_1.z.string(),
    sourceMethod: exports.MetadataCandidateSourceMethodSchema,
    supplier: catalogue_item_1.CatalogueNameSchema.nullable(),
});
exports.MetadataFieldClassificationSchema = zod_1.z.object({
    manufacturerPartNumberSourceField: zod_1.z
        .string()
        .nullable()
        .describe('Field name containing the manufacturer part number, or null if not present'),
    manufacturerNameSourceField: zod_1.z
        .string()
        .nullable()
        .describe('Field name containing the manufacturer name, or null if not present'),
    digikeyPartNumberSourceField: zod_1.z
        .string()
        .nullable()
        .describe('Field name containing the Digi-Key part number, or null if not present'),
    supplierPartNumberSourceField: zod_1.z
        .string()
        .nullable()
        .describe('Field name containing a non-DigiKey distributor / supplier part number ' +
        '(Mouser, LCSC, Arrow, Newark, generic supplier PN columns, etc.), or null if not present'),
    componentValueSourceField: zod_1.z
        .string()
        .nullable()
        .describe('Field name containing a single component value in SI units (Ω, F, H, V), or null if not present'),
});
//# sourceMappingURL=module-metadata-classification.js.map